import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-modal-conditions-information',
  templateUrl: './modal-conditions-information.component.html',
  styleUrls: ['./modal-conditions-information.component.scss']
})
export class ModalConditionsInformationComponent {
  @Output()
  modalOfertaChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  modalOfertaCookieChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  modalMainPositionChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public isModalConditionsInformation: boolean = false;
  public isDarkBackground: boolean = false;

  openModalTermsOfUsShow() {
    this.isModalConditionsInformation = true;
    this.isDarkBackground = true;
  }

  openOfertaModal() {
    this.modalOfertaChange.emit();
  }

  openOfertaCookieModal() {
    this.modalOfertaCookieChange.emit();
  }

  openMainPositionModal() {
    this.modalMainPositionChange.emit();
  }

  closeModal() {
    this.isModalConditionsInformation = false;
    this.isDarkBackground = false;
  }
}
